/* CERNUNOS - MEGA MENU (maquette Andre) - integration Turbo par PAKKO
   Delegation d'evenements : survit a InstantClick et a l'editeur de theme. */
(function () {
  'use strict';
  var MOBILE_MQ = '(max-width: 798px)';
  var hoverTimer = null;
  var lastTrigger = null;

  function isMobile() { return window.matchMedia(MOBILE_MQ).matches; }

  function setExpanded(item, state) {
    var btn = item.querySelector(':scope > .cernunos-nav__top .cernunos-nav__toggle');
    if (btn) btn.setAttribute('aria-expanded', state ? 'true' : 'false');
  }
  function openItem(item) { item.classList.add('is-open'); setExpanded(item, true); }
  function closeItem(item) { item.classList.remove('is-open'); setExpanded(item, false); }
  function closeAll(scope, except) {
    (scope || document).querySelectorAll('.cernunos-nav__item.is-open').forEach(function (it) {
      if (it !== except) closeItem(it);
    });
  }

  /* ---------- tiroir mobile ---------- */
  function panel() { return document.querySelector('.cernunos-nav--mobile .cernunos-nav__panel'); }
  function overlay() { return document.querySelector('.cernunos-nav--mobile .cernunos-nav__overlay'); }
  function drawerOpen() { var p = panel(); return !!(p && p.classList.contains('is-open')); }

  function openDrawer(trigger) {
    var p = panel(), o = overlay();
    if (!p) return;
    p.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.documentElement.classList.add('cernunos-drawer-open');
    lastTrigger = trigger || null;
    if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'true');
    var c = p.querySelector('.cernunos-nav__mobile-close');
    if (c) c.focus();
  }
  function closeDrawer(returnFocus) {
    var p = panel(), o = overlay();
    if (!p) return;
    p.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.documentElement.classList.remove('cernunos-drawer-open');
    closeAll(p);
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) lastTrigger.focus();
    }
  }

  /* ---------- clics (delegues) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('.cernunos-nav__toggle');
    if (toggle) {
      e.preventDefault(); e.stopPropagation();
      var item = toggle.closest('.cernunos-nav__item--has-menu');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      closeAll(item.closest('.cernunos-nav'), item);
      if (wasOpen) closeItem(item); else openItem(item);
      return;
    }
    var trig = t.closest('[data-cernunos-drawer-open]');
    if (trig) { e.preventDefault(); openDrawer(trig); return; }
    if (t.closest('.cernunos-nav__mobile-close') || t.closest('.cernunos-nav__overlay')) { closeDrawer(true); return; }
    if (!isMobile() && !t.closest('.cernunos-nav--desktop')) closeAll(document.querySelector('.cernunos-nav--desktop'));
  });

  /* ---------- survol desktop avec temporisation (pas de :hover CSS) ---------- */
  document.addEventListener('mouseover', function (e) {
    if (isMobile()) return;
    var item = e.target.closest('.cernunos-nav--desktop .cernunos-nav__item--has-menu');
    if (!item) return;
    var from = e.relatedTarget;
    if (from && item.contains(from)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { closeAll(item.closest('.cernunos-nav'), item); openItem(item); }, 130);
  });
  document.addEventListener('mouseout', function (e) {
    if (isMobile()) return;
    var item = e.target.closest('.cernunos-nav--desktop .cernunos-nav__item--has-menu');
    if (!item) return;
    var to = e.relatedTarget;
    if (to && item.contains(to)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { closeItem(item); }, 200);
  });

  /* ---------- clavier ---------- */
  document.addEventListener('focusout', function (e) {
    if (isMobile()) return;
    var item = e.target.closest('.cernunos-nav--desktop .cernunos-nav__item--has-menu');
    if (!item) return;
    var to = e.relatedTarget;
    if (to && item.contains(to)) return;
    closeItem(item);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawerOpen()) { closeDrawer(true); return; }
      var open = document.querySelector('.cernunos-nav--desktop .cernunos-nav__item.is-open');
      if (open) { var b = open.querySelector('.cernunos-nav__toggle'); closeItem(open); if (b) b.focus(); }
      return;
    }
    if (e.key === 'Tab' && drawerOpen()) {
      var p = panel();
      var f = Array.prototype.filter.call(p.querySelectorAll('a[href], button:not([disabled])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- changement de largeur ---------- */
  var wasMobile = isMobile();
  window.addEventListener('resize', function () {
    var m = isMobile();
    if (m === wasMobile) return;
    wasMobile = m;
    closeAll(document);
    if (!m) closeDrawer(false);
  });
})();
